import React, { useEffect, useRef, useState } from "react";

export const breakPoints = {
    xs: 320,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1280,
};

const ResponsiveWrapper = ({ children, className, onSizeChange }) => {
    const wrapperRef = useRef(null);
    const [breakpoints, setBreakpoints] = useState("");

    useEffect(() => {
        const _ro = new ResizeObserver((entries) => {
            const elWidth = entries[0].contentRect.width;
            const matchedBreakpoints = [];

            Object.entries(breakPoints).forEach(([breakpointName, width]) => {
                if (elWidth < width) matchedBreakpoints.push(breakpointName);
            });

            setBreakpoints(matchedBreakpoints.join(" "));

            if (onSizeChange) onSizeChange(elWidth);
        });

        _ro.observe(wrapperRef.current);

        return () => _ro.disconnect();
    }, []);

    return (
        <div className={`responsive-wrapper ${className} ${breakpoints}`} ref={wrapperRef}>
            {children}
        </div>
    );
};

export default ResponsiveWrapper;
